// Per-environment URLs and IDs. Hostname-based selection happens once at
// module load so consumers can just import `ENV`.

const ENVS = {
  prod: {
    webplayerScriptUrl: 'https://webplayer.sporteurope.tv/sporteurope-player.js',
    webplayerStyleUrl:  'https://webplayer.sporteurope.tv/style.css',
    usercentricsId: 'End-e5uG8',
    checkoutUrl: 'https://sporteurope.tv/kasse',
    loginUrl: 'https://sporteurope.tv',
    gaMeasurementId: 'G-58QEK70DQK',
  },
  stage: {
    webplayerScriptUrl: 'https://webplayer.sporteurope.stage.onl/sporteurope-player.js',
    webplayerStyleUrl:  'https://webplayer.sporteurope.stage.onl/style.css',
    usercentricsId: 'e3uV1YfB7YOOwf',
    checkoutUrl: 'https://sporteurope.stage.onl/kasse',
    loginUrl: 'https://sporteurope.stage.onl',
    gaMeasurementId: 'G-YSYNNSM2FT',
  },
  dev: {
    webplayerScriptUrl: 'https://webplayer.setv.test:5173/index.ts',
    webplayerStyleUrl:  'https://webplayer.setv.test:5173/style.css',
    usercentricsId: 'e3uV1YfB7YOOwf',
    checkoutUrl: 'https://sporteurope.setv.test/kasse',
    loginUrl: 'https://setv.test:4200',
    gaMeasurementId: 'G-YSYNNSM2FT',
  },
};

const host = location.hostname;
export const ENV_KEY = host.includes('setv.test') || host === 'localhost'
  ? 'dev'
  : host.includes('stage')
    ? 'stage'
    : 'prod';
export const ENV = ENVS[ENV_KEY];

// PLUS landing page lives on the aktionen domain regardless of environment.
// Only German and English variants exist; every other language falls back to German.
// The unprefixed path (without /de/) returns a 404, so the language segment is required.
export function plusUrl(lang) {
  return lang === 'en'
    ? 'https://aktionen.sporteurope.tv/en/sporteurope.tv-plus'
    : 'https://aktionen.sporteurope.tv/de/sporteurope.tv-plus';
}
